/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserActionLogDto } from '../../models/user-action-log-dto';

export interface UserActionLogControllerFindAll$Params {
}

export function userActionLogControllerFindAll(http: HttpClient, rootUrl: string, params?: UserActionLogControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserActionLogDto>>> {
  const rb = new RequestBuilder(rootUrl, userActionLogControllerFindAll.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UserActionLogDto>>;
    })
  );
}

userActionLogControllerFindAll.PATH = '/api/user-action-log';
